import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing, colors } = theme;

export default createUseStyles(
  {
    step: {
      display: 'flex',
      flexBasis: '100%',
      gap: spacing.sp01,
      overflow: 'hidden',
    },

    horizontal: {
      borderTop: [2, 'solid', colors.borderSubtle],
      padding: [spacing.sp02, spacing.sp04, 0, 0],
    },

    vertical: {
      borderLeft: [2, 'solid', colors.borderSubtle],
      padding: [0, 0, spacing.sp05, spacing.sp02],
    },

    highlighted: {
      borderColor: colors.borderInteractive,
      color: colors.iconLink,
    },

    text: {
      color: colors.textPrimary,
      overflow: 'hidden',
    },
    icon: {
      flexShrink: 0,
    },
    description: {
      color: colors.textTertiary,
    },
  },
  {
    name: 'Step',
  },
);
